export interface AlertReference {
  id: string
  reference: string
  design: string
  currentStock: number
  desiredStock: number
  incoming: number
  difference: number
  priority: 'critical' | 'high' | 'medium'
}
export interface Alert {
  id: string
  title: string
  count: number
  lastUpdate: string
  type:
    | 'low-stock'
    | 'critical-no-transit'
    | 'critical-with-orders'
    | 'excess-inventory'
  severity: 'critical' | 'high' | 'medium'
  references: AlertReference[]
}
export const alertsData: Alert[] = [
  {
    id: '1',
    title: 'Low stock or order required',
    count: 48,
    lastUpdate: 'Nov 6, 2025 1:00 AM',
    type: 'low-stock',
    severity: 'critical',
    references: [
      {
        id: '1',
        reference: 'PVM-5-GALV-001',
        design: '5" GALV',
        desiredStock: 20,
        currentStock: 2,
        incoming: 0,
        difference: -18,
        priority: 'critical',
      },
      {
        id: '2',
        reference: 'LIN-STD-002',
        design: 'Linear',
        desiredStock: 15,
        currentStock: 1,
        incoming: 0,
        difference: -14,
        priority: 'critical',
      },
      {
        id: '3',
        reference: 'PVM-6-5/8-POLY-003',
        design: '6" 5/8 POLY',
        desiredStock: 25,
        currentStock: 5,
        incoming: 3,
        difference: -17,
        priority: 'high',
      },
    ],
  },
  {
    id: '2',
    title: 'Critical stock with low in transit and not orders',
    count: 47,
    lastUpdate: 'Nov 6, 2025 1:00 AM',
    type: 'critical-no-transit',
    severity: 'critical',
    references: [
      {
        id: '1',
        reference: 'PVM-8-5/8-GALV-001',
        design: '8" 5/8 GALV',
        desiredStock: 30,
        currentStock: 3,
        incoming: 2,
        difference: -25,
        priority: 'critical',
      },
      {
        id: '2',
        reference: 'PVM-HP-STD-002',
        design: 'High Profile',
        desiredStock: 25,
        currentStock: 4,
        incoming: 1,
        difference: -20,
        priority: 'critical',
      },
    ],
  },
  {
    id: '3',
    title: 'Critical stock with low in transit and with orders',
    count: 7,
    lastUpdate: 'Nov 6, 2025 1:00 AM',
    type: 'critical-with-orders',
    severity: 'high',
    references: [
      {
        id: '1',
        reference: 'PVM-6-POLY-001',
        design: '6" POLY',
        desiredStock: 20,
        currentStock: 3,
        incoming: 8,
        difference: -9,
        priority: 'high',
      },
    ],
  },
]
